import { Theme } from "@mui/material";
import { makeStyles } from "@mui/styles";

const useStyles = makeStyles((theme: Theme) => ({
  avatar: {
    marginRight: theme.spacing(0.75),
  },
  divider: {
    margin: theme.spacing(1, 0),
  },
  link: {
    color: "inherit",
  },
  disabledLink: {
    color: "dimgray",
    pointerEvents: "none",
  },
  menu: {
    [theme.breakpoints.down("sm")]: {
      "& .MuiMenu-paper": {
        right: 0,
      },
    },
  },
}));

export default useStyles;
